import { Avatar, Badge, Flex, Modal, Pagination, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import {
  deleteHrUserById,
  getHrUsersList,
  getRoleList,
} from "../../api/hrUserApi";
import { deleteNotification } from "../../utils/useNotification";
import { useAuth } from "../../context/AuthContext";
import { notifications } from "@mantine/notifications";

import PanelUsersUpdateForm from "./PanelUsersUpdateForm";
import { useNavigate } from "react-router";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import TableEditButton from "../common/Buttons/TableEditButton";
import styled from "styled-components";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import CustomSelect from "../common/Inputs/CustomSelect";
import CustomSearchInput from "../common/Inputs/CustomSearchInput";
import CustomPagination from "../common/CustomPagination";

const PanelUsersTable = () => {
  const { user } = useAuth();

  const navigate = useNavigate();
  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  //for modal
  const [opened, setOpened] = useState(false);
  const [clickedUser, setClickedUser] = useState<any>();
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  //for select
  const [selectData, setSelectData] = useState<any>();
  const [selectedRole, setSelectedRole] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getHrUsersList({
        pageNumber: page,
        limit: limit,
        sort,
        privilege: selectedRole,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };

  const getRoles = async () => {
    try {
      const { data }: any = await getRoleList();
      setSelectData(data);
    } catch (error) {}
  };

  const handleDeleteClick = async (id: any) => {
    if (user?._id !== id) {
      try {
        const { data }: any = await deleteHrUserById({
          id,
        });
        deleteNotification(data?.success);
        const { data: updatedList }: any = await getHrUsersList({
          pageNumber: page,
          limit: limit,
        });
        setTableData(updatedList?.data);
      } catch (error) {
        console.error("Error generating key:", error);
      }
    } else {
      notifications.show({
        title: "Hata",
        message: "Silmeye çalışılan hesap giriş yapılı hesaptır.",
        color: "red",
        autoClose: 4000,
        withBorder: true,
      });
    }
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, opened, sort, selectedRole, searchedName]);

  useEffect(() => {
    getRoles();
  }, []);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            width: "100%",
            border: "1px solid #D1D5DB",
            height: "422px",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              value={searchedName}
              w={220}
              placeholder="Ad Soyad"
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
            <Flex gap={8}>
              <CustomSelect
                placeholder="Yetki/Rol"
                data={selectData}
                onChange={(e: any) => {
                  setSelectedRole(e);
                  setPage(1);
                }}
              />
            </Flex>
          </Flex>
          <Table
            style={{
              borderCollapse: "separate",
            }}
            verticalSpacing="sm"
          >
            <Table.Thead
              style={{
                background: "#EEF2FF",
              }}
            >
              <Table.Tr>
                <StyledTableTh style={{ width: "20%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Ad Soyad</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>Telefon</StyledTableTh>
                <StyledTableTh style={{ width: "15%" }}>
                  Yetki/Rol
                </StyledTableTh>
                <StyledTableTh style={{ width: "1%" }}></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((hrUser: any) => (
                <StyledTableTr
                  key={hrUser?._id}
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  <Table.Td>
                    <Flex justify={"start"} align={"center"} gap={16}>
                      <Badge
                        style={{ minWidth: "40px" }}
                        circle
                        bg={"#EEF2FF"}
                        size={"40px"}
                      >
                        <AvatarText>{hrUser?.name[0]}</AvatarText>
                      </Badge>
                      {hrUser?.name}
                    </Flex>
                  </Table.Td>
                  <Table.Td>{hrUser?.phone}</Table.Td>
                  <Table.Td>{hrUser?.privilege}</Table.Td>
                  <Table.Td>
                    <Flex gap={12}>
                      <TableEditButton
                        onClick={() => {
                          setClickedUser(hrUser);
                          setOpened(true);
                        }}
                      />
                      <TableDeleteButton
                        onClick={() => {
                          setitemToDeleteId(hrUser?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>

        <div
          style={{
            paddingTop: "24px",
          }}
        >
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>
      <Modal
        opened={opened}
        title="Panel Kullanıcısı Bilgisi Düzenleme"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={clickedUser?._id}
      >
        <PanelUsersUpdateForm
          closeModal={() => setOpened(false)}
          user={clickedUser}
        />
      </Modal>
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Panel Kullanıcısı Sil"
        text="Bu panel kullanıcısını silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default PanelUsersTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)``;

const AvatarText = styled.div`
  color: #21005d;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
`;
